module.exports = __webpack_public_path__ + "static/media/loadingImg.d6006d4b.svg";